// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   isRunning: false,
//   mode: 'one_time',
//   totalVehicles: 0,
//   completedVehicles: 0,
//   totalPackets: 0,
//   successCount: 0,
//   failCount: 0,
//   cycle: 1,
//   stepSize: 5,
//   framesPerVehicle: 5,
//   logs: [],
//   status: 'idle' // idle, running, stopped, completed
// };

// const simulationSlice = createSlice({
//   name: 'simulation',
//   initialState,
//   reducers: {
//     setStatus: (state, action) => {
//       return { ...state, ...action.payload };
//     },
//     addLog: (state, action) => {
//       state.logs.unshift(action.payload);
//       if (state.logs.length > 100) {
//         state.logs.pop();
//       }
//     },
//     clearLogs: (state) => {
//       state.logs = [];
//     },
//     resetSimulation: () => initialState
//   }
// });

// export const { setStatus, addLog, clearLogs, resetSimulation } = simulationSlice.actions;
// export default simulationSlice.reducer;





import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isRunning: false,
  mode: 'one_time',
  totalVehicles: 0,
  completedVehicles: 0,
  totalPackets: 0,
  successCount: 0,
  failCount: 0,
  cycle: 1,
  stepSize: 5,
  framesPerVehicle: 5,
  logs: [],  // ✅ Initialize as empty array
  status: 'idle'
};

const simulationSlice = createSlice({
  name: 'simulation',
  initialState,
  reducers: {
    setStatus: (state, action) => {
      return { ...state, ...action.payload };
    },
    addLog: (state, action) => {
      // ✅ Ensure logs is an array
      if (!state.logs) state.logs = [];
      state.logs.unshift(action.payload);
      if (state.logs.length > 100) {
        state.logs.pop();
      }
    },
    clearLogs: (state) => {
      state.logs = [];
    },
    resetSimulation: () => initialState
  }
});

export const { setStatus, addLog, clearLogs, resetSimulation } = simulationSlice.actions;
export default simulationSlice.reducer;